import { realApi } from './api';

// Una temporada entera (todas las modalidades, ida y vuelta) puede superar
// los 200 partidos — ya pasó en 2024-2025 y se comían las últimas jornadas
// sin avisar. 2000 es el tope real del backend (esquemaPaginacion): pedirlo
// de una vez evita paginar de verdad mientras el volumen no se acerque a eso.
export const getCalendarioReal = (temporadaId, { modalidad, jornada } = {}) => {
  const params = new URLSearchParams({ porPagina: '2000' });
  if (modalidad) params.set('modalidad', modalidad);
  if (jornada) params.set('jornada', String(jornada));
  return realApi
    .get(`/temporadas/${encodeURIComponent(temporadaId)}/calendario?${params}`)
    .then((r) => r.datos);
};

// Igual que getCalendarioReal, pero con los puntos de cada set y quién jugó
// cada lado: lo usa la pantalla de actas para pintar y corregir un partido
// sin pedirlos uno a uno.
export const getCalendarioDetalle = (temporadaId, { modalidad, jornada } = {}) => {
  const params = new URLSearchParams({ porPagina: '2000' });
  if (modalidad) params.set('modalidad', modalidad);
  if (jornada) params.set('jornada', String(jornada));
  return realApi
    .get(`/temporadas/${encodeURIComponent(temporadaId)}/calendario-detalle?${params}`)
    .then((r) => r.datos);
};

// Genera (o regenera) el calendario en el servidor: sustituye lo que antes
// era un round robin calculado en el navegador + N POST/DELETE de partidos
// sueltos. Sin `modalidad`, genera todas las modalidades abiertas de golpe.
// Solo funciona con la temporada en PLANIFICADA (si no, el backend responde
// 409 TEMPORADA_NO_PLANIFICADA).
export const generarCalendario = (temporadaId, modalidad) =>
  realApi
    .post(`/temporadas/${encodeURIComponent(temporadaId)}/calendario`, modalidad ? { modalidad } : {})
    .then((r) => r.datos);

// Calcula el round robin igual que generarCalendario, pero sin guardar
// nada: para enseñar un borrador ("PROVISIONAL") antes de confirmarlo con
// generarCalendario. Cada resultado trae también `calendario` (jornada,
// tipo, ids de local/visitante) para poder pintarlo sin haberlo guardado.
export const previsualizarCalendario = (temporadaId, modalidad) =>
  realApi
    .post(
      `/temporadas/${encodeURIComponent(temporadaId)}/calendario/previsualizar`,
      modalidad ? { modalidad } : {},
    )
    .then((r) => r.datos);

// Borra el calendario ya guardado de una modalidad (p.ej. si hay cambios de
// jugador/equipo antes de iniciar la temporada). Solo con PLANIFICADA.
export const borrarCalendario = (temporadaId, modalidad) =>
  realApi.delete(
    `/temporadas/${encodeURIComponent(temporadaId)}/calendario?modalidad=${encodeURIComponent(modalidad)}`,
  );
